var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductGroupForm',{attrs:{"data":_vm.data,"query":_vm.CREATE_PRODUCT_GROUP,"format-data-for-mutation":_vm.formatForMutation,"fetch-policy":"no-cache"},on:{"mutation-done":function($event){return _vm.$emit('product-group-created')}}})}
var staticRenderFns = []

export { render, staticRenderFns }